export const displayNameKeys = {
    asFirstName: 1,
    asAnonymous: 2,
    asCustomName: 3,
    asFullName: 4
};

export const displayNameOptions = [
    {
        key: displayNameKeys.asFirstName,
        translation: 'firstName',
        value: displayNameKeys.asFirstName,
        isAnonymous: false
    },
    {
        key: displayNameKeys.asFullName,
        translation: 'fullName',
        value: displayNameKeys.asFullName,
        isAnonymous: false
    },
    {
        key: displayNameKeys.asCustomName,
        translation: 'customName',
        value: displayNameKeys.asCustomName,
        isAnonymous: false
    },
    {
        key: displayNameKeys.asAnonymous,
        translation: 'anonymous',
        value: displayNameKeys.asAnonymous,
        isAnonymous: true
    }
];